export default [
  {
    path: '/apps/portador/list',
    name: 'apps-portador-list',
    component: () => import('@/views/cadastros/gerais/portador/list/Index.vue'),
    meta: {
      pageTitle: 'Portador',
      resource: 'AdminHanes',
    },
  },
  // {
  //     path: '/apps/portador/edit/:id',
  //     name: 'apps-portador-edit',
  //     component: () => import('@/views/cadastros-gerais/portador/portador-edit/PortadorEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Portador',
  //         resource: 'AdminHanes',
  //     },
  // },
];
